import type { MosaicNode } from "react-mosaic-component";
import type { ViewId } from "@/shared/types/common";

export function isWidgetOpened(
	tabLayout: MosaicNode<ViewId> | null,
	widgetName: ViewId,
): boolean {
	if (!tabLayout || !widgetName) return false;

	if (typeof tabLayout === "string") {
		if (tabLayout.startsWith(widgetName)) {
			return true;
		}
		return false;
	}

	const firstPart = tabLayout.first;
	const secondPart = tabLayout.second;

	return (
		isWidgetOpened(firstPart, widgetName) ||
		isWidgetOpened(secondPart, widgetName)
	);
}
